module.exports = __webpack_public_path__ + "img/cg2.cb042300.jpg";